import { Moment } from 'moment';
import React, { FC } from 'react';
import { Project } from 'api/project';
import { Category } from 'api/timesheets/categories';
import { Configuration } from 'api/timesheets/configuration/configuration';
import { endOfWeek } from 'components/organisms/timesheets/common/utils';
import { useTimesheetIntegrationsQuery } from 'queries/timesheets/calendar-integration-provider';
import {
  TimesheetCalendarIntegrationEntry,
  TimesheetWeeklyRow,
} from '../../types';
import { AddActivityPage } from './add-activity-page';
import { Loading } from './component';
import { ReAuthCalendar, SetupCalendar } from './setup-calendar';
import { getSourceTypeFromTimesheetConfig } from './util';

interface Props {
  visible: boolean;
  onClose: () => void;
  startDate: Moment;
  addIntegrationTaskToTimesheet: (
    task: TimesheetCalendarIntegrationEntry[],
  ) => void;
  projects?: Project[];
  timesheetWeekRows?: TimesheetWeeklyRow[];
  configuration: Configuration;
  timeEntryCategories: Category[];
}

export const CalenderDrawer: FC<Props> = ({
  onClose,
  startDate,
  visible,
  addIntegrationTaskToTimesheet,
  projects,
  timesheetWeekRows,
  configuration,
  timeEntryCategories,
}) => {
  const { data: integrations, isLoading } = useTimesheetIntegrationsQuery(
    getSourceTypeFromTimesheetConfig(configuration),
  );

  const integration = integrations?.find(
    (meta) => meta.integrationStatus === 'ACTIVE',
  );
  const expiredIntegration = integrations?.find(
    (meta) => meta.integrationStatus === 'AUTHENTICATION_EXPIRED',
  );

  if (isLoading) {
    return <Loading onClose={onClose} visible={visible} />;
  }

  return (
    <div>
      {!integration ? (
        expiredIntegration ? (
          <ReAuthCalendar
            onClose={onClose}
            visible={visible}
            configuration={configuration}
            expiredIntegration={expiredIntegration}
          />
        ) : (
          <SetupCalendar
            onClose={onClose}
            visible={visible}
            configuration={configuration}
          />
        )
      ) : (
        <AddActivityPage
          integration={integration}
          startDate={startDate.utc().startOf('day').valueOf()}
          endDate={endOfWeek(startDate).valueOf()}
          onClose={onClose}
          visible={visible}
          projects={projects}
          addIntegrationTaskToTimesheet={(tasks) => {
            addIntegrationTaskToTimesheet(tasks);
            onClose();
          }}
          timesheetWeekRows={timesheetWeekRows}
          configuration={configuration}
          timeEntryCategories={timeEntryCategories}
        />
      )}
    </div>
  );
};
